import "./bi.css";
import { useNavigateAndScroll } from "../../../hooks/useNavigateAndScroll";

const Content = () => {
  const navigateAndScroll = useNavigateAndScroll();
  return (
    <section
      className="light-section"
      style={{ marginTop: "4rem", marginBottom: "2rem" }}
      id="top"
    >
      <div className="columna">
        <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
          <span className="linea-negra"></span>
          <p className="datos-upper-text">Beneficios BI</p>
        </span>

        <p className="section-title">
          <span>
            Tomá el{" "}
            <span style={{ color: "var(--red-highlight)" }}>
              control de tu empresa
            </span>{" "}
            con inteligencia de negocios
          </span>
        </p>

        <p className="section-subtitle">
          ¿Te sientes perdido en un mar de datos? ¿Te cuesta tomar decisiones
          basadas en información precisa? Con binamics, puedes convertir tus
          datos en información valiosa que te ayudará a{" "}
          <span className="underscore">
            impulsar el crecimiento
            <img
              //   style={{}}
              src={`${process.env.PUBLIC_URL}/assets/imagenes/subrayado2-21.png`}
              alt="subrayado"
            />
          </span>{" "}
          de tu negocio.
        </p>

        <div
          //   style={{
          //     width: "70%",
          //     marginTop: "3rem",
          //     marginInline: "auto",
          //     backgroundColor: "white",
          //   }}
          className="bi-info-box"
        >
          <p className="bi-title">
            Con nuestra experiencia de Strategy y Power BI
          </p>

          <p className="bi-subtitle">
            Podemos crear soluciones de BI personalizadas que se adapten a las
            necesidades únicas de tu negocio.
          </p>
          <p className="bi-subtitle" style={{ fontWeight: 600 }}>
            ¿Qué plataforma es la adecuada para ti?
          </p>
          <p className="bi-subtitle">
            ¡Contáctanos para una consulta gratuita!
          </p>

          <button
            className="boton-generico boton-negro"
            style={{
              fontSize: "1.1rem",
              lineHeight: "1.1rem",
              marginTop: "3rem",
            }}
            onClick={() => navigateAndScroll("/demo", "top")}
          >
            Solicitar una demo
          </button>

          {/* <span className="bi-demo-wrapper">
            <p>Introduce tu correo electrónico</p>
          </span> */}
        </div>
      </div>

      <div className="columna" style={{ position: "relative", height: "100%" }}>
        <img
          alt="bi-main"
          src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/main-bi.png`}
          style={{
            width: "100%",
            position: "absolute",
            bottom: 0,
            right: "-5vw",
            //   width: 35%;
          }}
          //   className="bi-image"
        />
        <img
          alt="bi-main"
          src={`${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios/main-bi.png`}
          style={{
            width: "100%",
            visibility: "hidden",
            // position: "absolute",
            // bottom: 0,
            //   right: 1rem;
            //   width: 35%;
          }}
          //   className="bi-image"
        />
      </div>
    </section>
  );
};

export default Content;
